import { render, staticRenderFns } from "./BurnSamples.vue?vue&type=template&id=546efbb5&scoped=true"
import script from "./BurnSamples.vue?vue&type=script&lang=js"
export * from "./BurnSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546efbb5",
  null
  
)

export default component.exports